import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

const AboutPage = lazy(() => import('../pages/about'));
const CircularIdeasPage = lazy(() => import('../pages/circularIdeas'));
const HomePage = lazy(() => import('../pages/home'));

// Admin Pages
const AdminLoginPage = lazy(() => import('../pages/admin/AdminLoginPage'));
const Dashboard = lazy(() => import('../pages/admin/Dashboard'));
const AdminLayout = lazy(() => import('../components/admin/AdminLayout'));
const ProtectedRoute = lazy(() => import('../components/admin/ProtectedRoute'));

// Admin Components
const ProductManagement = lazy(() => import('../pages/admin/ProductManagement'));
const IdeaManagement = lazy(() => import('../pages/admin/IdeaManagement'));

// ----------------------------------------------------------------------

export default function Router() {
    return useRoutes([
        {
            path: 'portal',
            children: [
                { path: 'login', element: <Suspense fallback={<></>}><AdminLoginPage /></Suspense> },
                {
                    path: '',
                    element: (
                        <Suspense fallback={<></>}>
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    children: [
                        { element: <Dashboard />, index: true },
                        { path: 'waste', element: <ProductManagement type={1} /> },
                        { path: 'end-product', element: <ProductManagement type={2} /> },
                        { path: 'ideas', element: <IdeaManagement /> },
                    ],
                },
            ],
        },
        {
            path: 'about',
            element: <Suspense fallback={<></>}><AnimatePresence wait initial={false}><AboutPage /></AnimatePresence></Suspense> ,
        },
        {
            path: 'circular-ideas',
            element: <Suspense fallback={<></>}><AnimatePresence wait initial={false}><CircularIdeasPage /></AnimatePresence></Suspense>,
        },
        {
            path: '/',
            element: <Suspense fallback={<></>}><AnimatePresence wait initial={false}><HomePage /></AnimatePresence></Suspense>,
        },
        {
            path: '*',
            element: <Suspense fallback={<></>}><AnimatePresence wait initial={false}><Navigate to="/404" replace /></AnimatePresence></Suspense>,
        },
    ]);
}

